import { z } from 'zod';
/** Suggested roles a contact can play on an audition (free text is also allowed). */
export const CONTACT_ROLES = [
    'Casting Director',
    'Casting Associate',
    'Casting Assistant',
    'Director',
    'Producer',
    'Agent',
    'Manager',
    'Photographer',
    'Other',
];
export const contactInputSchema = z.object({
    full_name: z.string().trim().min(1).max(160),
    email: z.string().trim().max(200).nullable().optional(),
    phone: z.string().trim().max(40).nullable().optional(),
    company: z.string().trim().max(160).nullable().optional(),
    title: z.string().trim().max(120).nullable().optional(),
    notes: z.string().max(4000).nullable().optional(),
});
export const contactSchema = contactInputSchema.extend({
    id: z.string().uuid(),
    business_id: z.string().uuid(),
    created_at: z.string(),
});
/** Link payload: an existing contact (or a freshly created one, handled server-side) + a role on this audition. */
export const opportunityContactInputSchema = z.object({
    contact_id: z.string().uuid(),
    role: z.string().trim().max(80).nullable().optional(),
});
//# sourceMappingURL=contacts.js.map